/**
 * Release 8, incremental laptop scans: how often laptop agents read every file
 * (controller migration 0214, GET/PUT /v1/edge/fleet-policy/scan). Between
 * those scans a laptop reads only the files that changed since it last read
 * them. Its own file so the shared api.ts is not touched by this release item.
 */
import { apiFetch } from './api';

export interface FullScanPolicyRow {
  scopeType: 'tenant' | 'business_unit';
  businessUnitId: string | null;
  businessUnitName: string | null;
  /** null = not set at this level (inherits). 0 = every scan reads every file. */
  fullScanEveryDays: number | null;
  updatedBy: string | null;
  updatedAt: string | null;
  editable: boolean;
}

export interface FullScanPolicyView {
  tenant: FullScanPolicyRow | null;
  businessUnits: FullScanPolicyRow[];
  defaultDays: number;
  maxDays: number;
  statement: { incremental: string; full: string; closes: string; zero: string };
}

export async function getFullScanPolicy(): Promise<FullScanPolicyView> {
  return apiFetch('/v1/edge/fleet-policy/scan');
}

export async function setFullScanPolicy(input: {
  scopeType: 'tenant' | 'business_unit';
  businessUnitId?: string;
  fullScanEveryDays: number | null;
  reason: string;
}): Promise<{ policy: FullScanPolicyRow }> {
  return apiFetch('/v1/edge/fleet-policy/scan', { method: 'PUT', body: JSON.stringify(input) });
}
